var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('PCNavbar',{attrs:{"selectIndex":"1"}}),_c('MobileNavBar',{attrs:{"currentActive":0}}),_c('div',{staticClass:"null-class"}),_c('router-view'),_c('BackTop'),_c('CallMe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }